import { ControllerProps } from "csi/middleware/common";
import { featureTogglesStore } from "csi/state/rootStore";
import { useLocalReactionStore } from "designSystem/hooks";
import { SaveDialog } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import MaterialCompositionDrawer from "../MaterialCompositionDrawer";
import CompositionData from "./CompositionData";
import CompositionSingleItem from "./CompositionSingleItem";
import { CompositionStore, CompositionStoreContext } from "./CompositionStore";
import CompositionWithoutSustainabilitySingleItem from "./CompositionWithoutSustainabilitySingleItem";

interface CompositionSaveDialogWrapperProps extends ControllerProps {}

const CompositionSaveDialogWrapper: FunctionComponent<CompositionSaveDialogWrapperProps> = observer(function CompositionSaveDialogWrapper(props) {
	const {
		store,
		...otherProps
	} = props;
	const compositionStore = store as CompositionStore;
	const {
		clearComposition,
		compositionGuidanceSatisfied,
		compositions,
		count,
		currentMaterialAttribute,
		disableSave,
		hasSustainability,
		hint,
		onSave,
	} = compositionStore;

	const singleItemComponent = !hasSustainability ? CompositionWithoutSustainabilitySingleItem : CompositionSingleItem;

	return (
		<>
			{compositionStore && (
				<CompositionStoreContext.Provider value={compositionStore}>
					<SaveDialog
						{...otherProps}
						disableEnforceFocus
						disableSave={disableSave}
						fullHeight
						onSave={onSave}
						open
						rightDrawerProps = {{
							disabled: true,
							drawerNode: (
								<MaterialCompositionDrawer
									SingleItemComponent={singleItemComponent}
									clearComposition={clearComposition}
									compositionGuidanceSatisfied={compositionGuidanceSatisfied}
									compositions={compositions}
									count={count}
									hint={hint}
									hintTitle="CompositionMaterials"
									parentTechnicalComposition={currentMaterialAttribute}
								/>
							),
							open: true,
							widthOpen: 300,
						}}
						width={1200}
					>
						{{ main: <CompositionData /> }}
					</SaveDialog>
			  </CompositionStoreContext.Provider>

			)}
		</>
	);
});

export default CompositionSaveDialogWrapper;